module.exports = __webpack_public_path__ + "img/manually.73abf540.jpg";